import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <h1>Restaurant Admin</h1>
      <div className="admin-info">
        <span>{user?.username || 'Admin User'}</span>
        <div className="admin-actions">
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
          <div className="admin-avatar">
            {user?.username?.[0]?.toUpperCase() || 'A'}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
